<style lang="scss" scoped>
@import "./cart.scss";
</style>
<script>
import CartItems from '../cart-items/cart-items'
import { mapGetters } from 'vuex'
import { EventBus } from '../../event-bus'
import sharedService from '../../utils/shared-service'
import {
  CONSTANT,
  APP_EXTERNAL_LINKS,
  PAYMENT_OPTIONS,
  PAYMENT_OPTION_LABELS,
  CLICK_TO_PAY,
  PAY_BY_CARD,
  DEFAULT_CHECKOUT_EXPERIENCE,
  INVISIBLE_CHECKOUT_EXPERIENCE,
  INLINE_CHECKOUT_EXPERIENCE,
  SCOF_FLOW,
  AUTH_METHODS,
  MFA_METHODS,
  MFA_API_METHODS,
  SCOF_AUTH_NTS,
  windowRefTypes,
  SCOF_AUTH_ICT,
  SCOF_AUTH_ENC
} from '../../utils/constant'
import traceService from '../shared/trace/trace-service'
import SdkLogo from '../sdk-logo/sdk-logo'
import InvisibleSrci from '../invisibe-srci/invisibe-srci'
import payByCard from '../pay-by-card/pay-by-card'
import payBySavedCard from '../pay-by-saved-card/pay-by-saved-card.vue'
import CardPaymentInfo from '../card-payment-info/card-payment-info.vue'
import toasterService from '../../utils/toaster'
import requestBody from '../../orchestration/authSDK/request-parameter'

export default {
  name: 'Cart',

  components: {
    InvisibleSrci,
    CartItems,
    SdkLogo,
    payByCard,
    payBySavedCard,
    CardPaymentInfo
  },
  data () {
    return {
      defaultPaymentOption: CLICK_TO_PAY,
      paymentOptions: PAYMENT_OPTIONS,
      paymentOptionLabels: PAYMENT_OPTION_LABELS,
      preCheckoutLoader: true,
      invisibleCheckout: false,
      showClickToPay: true,
      appExternalLinks: APP_EXTERNAL_LINKS,
      clickToPay: CLICK_TO_PAY,
      payByCard: PAY_BY_CARD,
      isCardValid: false,
      error: '',
      dpaId: null,
      cofDpaids: [],
      isCardPaymentInfoVisible: true,
      disableSavedCardContinueButton: true,
      selectedSavedCardIndex: 0,
      selectedSavedCard: null,
      activeComp: 'card-payment-info',
      selectedCheckoutApproach: null,
      hidePayBySavedCard: false,
      isUnbindRequested: false,
      disableUnbindButton: true,
      sessionAssuranceValue: null
    }
  },

  computed: {
    ...mapGetters([
      'totalItems',
      'selectedCheckoutExperience',
      'allSdkLoaded',
      'cartDetails',
      'isRecognized',
      'dpaIds',
      'consumerJwt',
      'merchantSavedCards',
      'scofDpaId',
      'enableB2bAuthLookupFIDO',
      'region',
      'c2pSelectedCurrency',
      'consumerInfo',
      'enrollMaskCard',
      'isConsumerAuthModuleEnable',
      'windowRefType',
      'enableTokenizationConsent',
      'enableENCFlow'
    ]),

    isLoggedIn: function () {
      return this.consumerJwt
    },

    srcNetwork: {
      get () {
        return this.$store.getters.srcNetwork
      }
    },

    selectedSavedCardDetails: {
      get () {
        return this.$store.getters.selectedSavedCardDetails
      },
      set (value) {
        this.$store.commit('setSelectedSavedCardDetails', value)
      }
    },

    selectedBindingDetails: {
      get () {
        return this.$store.getters.selectedBindingDetails
      },
      set (value) {
        this.$store.commit('setSelectedBindingDetails', value)
      }
    }
  },

  watch: {
    defaultPaymentOption: {
      handler (value) {
        if (value === CLICK_TO_PAY) {
          this.$store.commit('changeCurrency', this.c2pSelectedCurrency)
        } else {
          this.region === CONSTANT.REGION.GLOBAL ? this.$store.commit('changeCurrency', this.c2pSelectedCurrency) : this.$store.commit('changeCurrency', CONSTANT.SCOF_CURRENCY[this.region])
        }
        this.showClickToPay = this.defaultPaymentOption === CLICK_TO_PAY
        this.selectedSavedCardDetails = null
        this.activeComp = 'card-payment-info'
      }
    }
  },

  created () {
    this.initialConfiguration()
    this.$store.commit('setSelectedSavedCardDetails', null)
    this.$store.commit('setScofExecutionFlow', '')
    this.$store.commit('setTraceId', null)
    this.selectedBindingDetails = null
    this.$store.commit('setEnableNTSFlow', false)
    sharedService.clearStore()
  },

  mounted () {
    EventBus.$on('switchConsumer', () => {
      this.invisibleCheckout = !(
        this.selectedCheckoutExperience === INLINE_CHECKOUT_EXPERIENCE
      )
    })
    EventBus.$on('changeConfiguration', (event) => {
      this.preCheckoutLoader = true
      this.initialConfiguration()
    })
    EventBus.$on('returnToMerchant', (event) => {
      this.invisibleCheckout = false
    })
    this.cofDpaids = this.dpaIds.filter((dpa) => {
      return dpa['displayDpaName'].includes('COF')
    })
    this.dpaId = this.cofDpaids[0]

    EventBus.$on('authUIResponse', this.handlerAuthUIResponse)

    EventBus.$on('handleError', (event) => {
      this.error = event
      setTimeout(() => {
        this.error = ''
      }, 3000)
    })
  },

  beforeDestroy () {
    EventBus.$off('authUIResponse', this.handlerAuthUIResponse)
  },

  methods: {

    handlerAuthUIResponse (event) {
      if (event.from === 'checkout' && event.type === 'Error') {
        this.$store.dispatch('lightBoxloaderOn', false)
        clearInterval(sharedService.authUIPopupCloseTimer)
        toasterService.onFailure('Popup window is closed unexpected')
        this.checkoutWithNativeFlow()
      } else {
        this.$store.dispatch('lightBoxloaderOn', false)
        this.processAuthUiResponse(event)
      }
    },

    async checkoutWithNativeFlow () {
      await this.executeCheckout()
    },

    async processAuthUiResponse (result) {
      console.log('Auth UI Response', result)
      let response = {}
      if (result === 'AUTHENTICATION_SUCCESS') {
        response = await this.callResultB2BAPI(this.selectedSavedCardDetails, this.sessionAssuranceValue)
        this.executeCheckout(response.authenticationsResultsResponse.assuranceData)
      }
      if (result === 'AUTHENTICATOR_NOT_AVAILABLE') {
        toasterService.onFailure('No passkey is bound to the card')
        EventBus.$emit('handleError', this.error)
        this.executeCheckout()
      }
      if (result === 'AUTHENTICATION_FAILED') {
        toasterService.onFailure('Authentication has failed')
        response = await this.callResultB2BAPI(this.selectedSavedCardDetails, this.sessionAssuranceValue)
        this.executeCheckout(response.authenticationsResultsResponse.assuranceData)
      }
      if (result === 'NOT_AUTHENTICATED') {
        toasterService.onFailure('User declined')
        this.executeCheckout()
      }
    },

    initialConfiguration () {
      if (this.totalItems) {
        this.allSdkLoaded && this.initializeSDK()
      }
    },

    /**
     * Load SRC SDK JS while route to cart page
     */
    async initializeSDK () {
      try {
        this.$store.commit('updateSRCTotalPrice', CONSTANT.SRC.CART)
        sharedService.intializeSdk().then(() => {
          this.preCheckoutLoader = false
          if (this.selectedCheckoutExperience !== DEFAULT_CHECKOUT_EXPERIENCE && this.isRecognized.recognized) {
            if (this.isConsumerAuthModuleEnable && (this.windowRefType === windowRefTypes.ACTION_SHEET || this.windowRefType === windowRefTypes.POPUP)) {
              this.invisibleCheckout = false
            } else {
              this.invisibleCheckout = true
            }
          }
          console.info('Pre Checkout completed Successfully')
        })
      } catch (e) {
        console.warn('Error occurs while calling pre checkout')
      }
    },

    /**
     * This method invoke srci
     */
    openSrc () {
      if (this.isConsumerAuthModuleEnable) {
        if (this.windowRefType === windowRefTypes.IFRAME) {
          this.invisibleCheckout = true
        } else if (this.windowRefType === windowRefTypes.ACTION_SHEET) {
          EventBus.$emit('openActionsheet', true)
        } else {
          sharedService.invokeSrc(this.$router, CONSTANT.SRC.CART, this.$store)
        }
      } else {
        if (
          (this.selectedCheckoutExperience === INVISIBLE_CHECKOUT_EXPERIENCE &&
          !this.isRecognized.recognized) ||
        (this.selectedCheckoutExperience !== DEFAULT_CHECKOUT_EXPERIENCE &&
          this.isRecognized.recognized)
        ) {
          this.invisibleCheckout = true
        } else {
          sharedService.invokeSrc(this.$router, CONSTANT.SRC.CART, this.$store)
        }
      }
    },

    /**
     * This method routes to account page
     */
    accountPage () {
      this.$router.push('/account').catch((err) => {
        console.error(err)
      })
    },

    /**
     * This method makes the cart empty
     */
    emptyCart () {
      this.$store.dispatch('decrement')
    },

    /**
     * This method routes to Home page
     */
    homePage () {
      this.$router.push('/').catch((err) => {
        console.error(err)
      })
    },

    cancel () {
      this.$store.dispatch('updateRememberMeConsent', false)
      this.invisibleCheckout = false
    },

    async executeCheckout (assuranceData = null) {
      try {
        this.$store.commit('loaderOn', true)
        let maskedCardData = this.selectedSavedCardDetails.maskedCard
        this.$store.commit('setConsumerContactInfo', '')

        const correlationId = this.selectedSavedCardDetails.srcCorrelationId
        let response = await sharedService.getScofPayloadApiResponse(requestBody[AUTH_METHODS.B2B_CHECKOUT_TRANSACTION_AUTHENTICATION](maskedCardData, assuranceData, correlationId))
        let consumerContactInfo = response.decryptedCheckoutResponse.checkoutResponseJWSPayload.maskedConsumer.maskedConsumerIdentity.maskedIdentityValue
        traceService.updateCallTraces(this.srcNetwork, response.callTraces, true)
        toasterService.onSuccess(this.$t('successMessages.PAYLOAD_SUCCESS'))
        this.$store.commit('setConsumerContactInfo', consumerContactInfo)
        this.$store.commit('loaderOn', false)
        if (consumerContactInfo !== '') {
          this.$store.dispatch('decrement')
          this.$router.push('/authreview').catch(err => { console.error(err) })
          this.$store.commit('lightBoxloaderOn', false)
        }
      } catch (err) {
        this.$store.commit('loaderOn', false)
        let errorLog = err?.response?.data?.callTraces
        traceService.updateCallTraces(this.srcNetwork, errorLog, true)
        this.error = this.$t('PAYLOAD_ERROR')
      }
    },

    async transtionAuthenticationNativeFlow () {
      const network = 'mastercard'
      const srcDigitalCardId = this.selectedSavedCard.scofMaskedCard.srcDigitalCardId
      await this.getAuthMethodsByLookup()
      if (this.selectedSavedCardDetails) {
        this.$store.commit('loaderOn', true)
        const srcCorrelationId = this.selectedSavedCardDetails.srcCorrelationId
        const serviceId = this.selectedSavedCardDetails.maskedCard.serviceId

        let reqParams = requestBody[AUTH_METHODS.B2B_NTS_TRANSTION_AUTHENTICATION](
          srcCorrelationId,
          srcDigitalCardId,
          serviceId
        )
        try {
          let authResponse = await sharedService.getB2BAuthenticateApiResponse(reqParams)
          traceService.updateCallTraces(network, authResponse.callTraces, true)
          this.$store.commit('loaderOn', false)
          return authResponse
        } catch (err) {
          toasterService.onFailure(this.$t('Authentication API Failed'))
          this.$store.commit('loaderOn', false)
          let errorLog = err.response.data.callTraces
          traceService.updateCallTraces(network, errorLog, false)
          this.error = err.response.data.message
          EventBus.$emit('handleError', this.error)
          return false
        }
      }
    },

    async checkoutWithSavedCard () {
      if (this.$store.getters.enableNativeIntegrationFlow) {
        let authResponse = await this.transtionAuthenticationNativeFlow()
        if (authResponse) {
          this.sessionAssuranceValue = authResponse.authenticateResponse.sessionAssuranceValue
          const authURl = authResponse.authenticateResponse.methodAttributes.uriData.uri
          sharedService.openAuthUI(authURl, this.sessionAssuranceValue, 'checkout')
        } else {
          await this.executeCheckout()
        }
        return
      }
      this.activeComp === 'card-payment-info'
        ? this.getAuthMethodsByLookup()
        : this.performCheckout()
    },

    async unbindMFA (key, additionalKey = null) {
      const {
        certifiedMfaMethodId,
        mfaMethodInstanceId,
        externalMfaMethodInstanceId,
        srcDigitalCardId,
        serviceId,
        srcCorrelationId
      } = this.selectedBindingDetails

      if (certifiedMfaMethodId === '10031') {
        this.$store.commit('setThirdPartyFIDO', true)
      } else {
        this.$store.commit('setThirdPartyFIDO', false)
      }

      let requestParam
      switch (key) {
        case 'mfaMethodInstanceId':
          requestParam = requestBody[MFA_METHODS.UNBIND](key, mfaMethodInstanceId, srcDigitalCardId, certifiedMfaMethodId, serviceId, srcCorrelationId)
          break
        case 'externalMfaMethodInstanceId':
          requestParam = requestBody[MFA_METHODS.UNBIND](key, externalMfaMethodInstanceId, srcDigitalCardId, certifiedMfaMethodId, serviceId, srcCorrelationId)
          break
        case 'resourceId':
          const params = additionalKey === 'externalMfaMethodInstanceId' ? externalMfaMethodInstanceId : mfaMethodInstanceId
          requestParam = requestBody[MFA_METHODS.UNBIND](key, params, srcDigitalCardId, certifiedMfaMethodId, serviceId, srcCorrelationId, additionalKey)
          break
        default:
          requestParam = requestBody[MFA_METHODS.UNBIND](key, mfaMethodInstanceId, srcDigitalCardId, certifiedMfaMethodId, serviceId, srcCorrelationId)
          break
      }
      try {
        this.$store.commit('loaderOn', true)
        this.error = ''
        let response = await sharedService.getBindMfaApiResponse(requestParam, MFA_API_METHODS.UNBIND)
        traceService.updateCallTraces(this.srcNetwork, response.callTraces, true)
        toasterService.onSuccess(this.$t('successMessages.UNBIND_SUCCESS'))
        this.$store.commit('loaderOn', false)
        this.updateConsumerDetails(certifiedMfaMethodId)
        this.isUnbindRequested = false
        this.disableSavedCardContinueButton = true
        this.activeComp = 'card-payment-info'
      } catch (err) {
        this.$store.commit('loaderOn', false)
        let errorLog = err.response.data.callTraces
        traceService.updateCallTraces(this.srcNetwork, errorLog, true)
        this.error = this.$t('UNBIND_MFA_FAILED')
      }
    },

    async updateConsumerDetails (certifiedMfaMethodId) {
      const deviceId = localStorage.getItem(CONSTANT.APP_INSTANCE_KEY)
      let deviceData = this.consumerInfo.consumerDeviceData
      if (deviceData[deviceId] && certifiedMfaMethodId === '10031') {
        delete deviceData[deviceId]
      }
      let selectedCard = this.consumerInfo.merchantCardIds.find(card => card.scofMaskedCard.srcDigitalCardId === this.selectedSavedCard.scofMaskedCard.srcDigitalCardId)
      const certifiedMfaId = selectedCard.bindingIds[deviceId]
      if (certifiedMfaId && Object.keys(certifiedMfaId).length === 1) {
        selectedCard.bindingIds = {}
      } else {
        delete certifiedMfaId[certifiedMfaMethodId]
      }
      this.$store.commit('changeConsumerInfo', this.consumerInfo)
    },

    async getAuthMethodsByLookup () {
      this.$store.commit('loaderOn', true)
      const { srcDigitalCardId } =
        this.selectedSavedCard.scofMaskedCard
      let response = await this.authenticateMethodsLookupB2B(srcDigitalCardId)
      if (response.authenticationMethods.length > 0) {
        response['maskedCard'] = this.selectedSavedCard.scofMaskedCard
        response.maskedCard.digitalCardData['authenticationMethods'] = response.authenticationMethods
        response.maskedCard['mfaEligibility'] = response?.mfaEligibility
        this.$store.commit('loaderOn', false)
        if (this.$store.getters.enableNativeIntegrationFlow === false) {
          this.activeComp = 'pay-by-saved-card'
          this.disableSavedCardContinueButton = true
        }
        this.selectedSavedCardDetails = response
      } else {
        this.$store.commit('loaderOn', false)
        toasterService.onFailure(this.$t('errorMessages.NO_AUTH_METHODS'))
        return false
      }
    },

    getPayByCardComponentInstance () {
      return this.$children.find(
        (child) => child.$options.name === 'PayByCard'
      )
    },

    performCheckout () {
      this.selectedBindingDetails ? this.checkoutUsingBindingDetails() : this.checkoutUsingIdvApproach()
    },

    checkoutUsingIdvApproach () {
      this.disableSavedCardContinueButton = false
      const authReason = 'TRANSACTION_AUTHENTICATION'
      let authenticationMethod
      let executionContextComponent = this.getPayByCardComponentInstance()
      if (executionContextComponent) {
        switch (this.selectedCheckoutApproach) {
          case '3DS_PA':
            this.$store.commit('setScofExecutionFlow', '3DS')
            authenticationMethod = this.selectedSavedCardDetails.maskedCard.digitalCardData.authenticationMethods.filter(method => method.authenticationMethodType === '3DS')[0]
            executionContextComponent.initiateFlow(
              authenticationMethod,
              authReason,
              true,
              this.selectedSavedCardDetails
            )
            break
          case 'MANAGED_AUTHENTICATION':
            this.$store.commit('setScofExecutionFlow', '3DS')
            authenticationMethod = this.selectedSavedCardDetails.maskedCard.digitalCardData.authenticationMethods.filter(method => method.authenticationMethodType === 'MANAGED_AUTHENTICATION')[0]
            executionContextComponent.initiateFlow(
              authenticationMethod,
              authReason,
              true,
              this.selectedSavedCardDetails
            )
            break
          case 'MDES_IDV':
            this.$store.commit('setScofExecutionFlow', SCOF_FLOW['MDES_IDV'])
            executionContextComponent.enableCardDetail = false
            executionContextComponent.isExistingCard = true
            this.hidePayBySavedCard = true
            executionContextComponent.enrollCardData = this.selectedSavedCardDetails
            setTimeout(() => {
              const authComponent = executionContextComponent.$refs.authComponent
              if (authComponent) {
                authComponent.selectedSCOFFlow = SCOF_FLOW['MDES_IDV']
              }
            }, 100)
            break

          default:
            break
        }
      }
    },

    checkoutUsingBindingDetails () {
      this.$router.push('/authreview').catch(err => { console.error(err) })
    },

    resetComponent () {
      this.hidePayBySavedCard = false
      this.isUnbindRequested = false
      this.activeComp = 'card-payment-info'
      this.$store.commit('setSelectedSavedCardDetails', null)
      this.disableSavedCardContinueButton = true
      let executionContextComponent = this.getPayByCardComponentInstance()
      if (executionContextComponent) {
        executionContextComponent.enableCardDetail = true
        executionContextComponent.isExistingCard = false
        executionContextComponent.enrollCardData = this.selectedSavedCardDetails
      }

      this.$store.commit('setScofExecutionFlow', '')
    },

    // eslint-disable-next-line complexity
    async authenticateMethodsLookupB2B (srcDigitalCardId, srcCorrelationId = null) {
      this.$store.commit('loaderOn', true)
      const network = 'mastercard'
      if (!srcCorrelationId) {
        srcCorrelationId = sharedService.generateUUID()
      }
      const authReason = 'TRANSACTION_AUTHENTICATION'
      let reqParams = requestBody[AUTH_METHODS.B2BAUTHLOOKUP](
        authReason,
        srcCorrelationId,
        srcDigitalCardId
      )
      if (sharedService.checkFeatureFlag('START_NTS_CHANGES') && this.$store.getters.enableNativeIntegrationFlow) {
        reqParams['flowType'] = SCOF_AUTH_NTS
      }

      if (sharedService.checkFeatureFlag('START_ICT_CHANGES') && this.enableTokenizationConsent) {
        reqParams['flowType'] = SCOF_AUTH_ICT
      }

      if (sharedService.checkFeatureFlag('START_ENC_CHANGES') && this.enableENCFlow) {
        reqParams['flowType'] = SCOF_AUTH_ENC
      }
      try {
        let response = await sharedService.getB2BAuthLookupApiResponse(reqParams)
        traceService.updateCallTraces(network, response.callTraces, true)
        try {
          let header = JSON.parse(response.callTraces[0]?.responseBody).headers
          let traceIdKey = Object.keys(header).find(
            key => key.toLowerCase() === 'x-src-cx-flow-id'
          )
          let traceId = traceIdKey ? header[traceIdKey] : null
          this.$store.commit('setTraceId', traceId)
        } catch (error) {
          toasterService.onFailure(this.$t('errorMessages.B2B_AUTH_LOOKUP_TRACE_ID_MISSING'))
        }
        this.$store.commit('loaderOn', false)
        return response.b2BLookupAuthenticationResponse
      } catch (err) {
        toasterService.onFailure(this.$t('errorMessages.LOOKUP_B2B_FAILED'))
        this.$store.commit('loaderOn', false)
        let errorLog = err.response.data.callTraces
        traceService.updateCallTraces(network, errorLog, false)
        return false
      }
    },

    async callGetCardB2BApi (srcDigitalCardId) {
      const network = 'mastercard'
      const reqParams = {
        environmentId: this.$store.getters.environment,
        region: this.region,
        scofCardRequest: {
          cardId: srcDigitalCardId,
          srcClientId: this.$store.getters.srcInitiatorIdByNetwork(0),
          srcDpaId: this.scofDpaId
        }
      }
      if (sharedService.checkFeatureFlag('START_NTS_CHANGES') && this.$store.getters.enableNativeIntegrationFlow) {
        reqParams['flowType'] = SCOF_AUTH_NTS
      }

      try {
        const response = await sharedService.getSavedCardDetails(reqParams)
        traceService.updateCallTraces(network, response.callTraces, true)
        try {
          let traceIdKey = Object.keys(response.headers).find(
            key => key.toLowerCase() === 'x-src-cx-flow-id'
          )
          let traceId = traceIdKey ? response.headers[traceIdKey][0] : null
          this.$store.commit('setTraceId', traceId)
        } catch (error) {
          toasterService.onFailure(this.$t('errorMessages.GET_CARDS_TRACE_ID_MISSING'))
        }
        return response.getCardResponse
      } catch (err) {
        toasterService.onFailure(this.$t('errorMessages.GET_CARDS_B2B_FAILED'))
        let errorLog = err.response.data.callTraces
        traceService.updateCallTraces(network, errorLog, false)
        this.$store.commit('loaderOn', false)
      }
    },

    onCardInfoChange (card) {
      this.selectedSavedCard = card
      this.disableSavedCardContinueButton = false
    },

    navigateToUnbind (card) {
      this.selectedSavedCard = card
      this.disableSavedCardContinueButton = true
      this.isUnbindRequested = true
      this.activeComp = 'pay-by-saved-card'
    },

    checkoutApproachChange (approach) {
      this.selectedCheckoutApproach = approach
      this.disableSavedCardContinueButton = false
    },

    bindingDetailsChange (details) {
      this.disableSavedCardContinueButton = false
      this.selectedBindingDetails = details
      this.disableUnbindButton = false
    },

    async callResultB2BAPI (maskedCardData, sessionAssuranceValue) {
      try {
        this.$store.commit('loaderOn', true)
        this.$store.commit('setConsumerContactInfo', '')
        let response = await sharedService.getScofResultApiResponse(requestBody[MFA_METHODS.B2B_RESULT](maskedCardData, sessionAssuranceValue))
        traceService.updateCallTraces(this.srcNetwork, response.callTraces, true)
        toasterService.onSuccess(this.$t('successMessages.RESULT_SUCCESS'))
        this.$store.commit('loaderOn', false)
        return response
      } catch (err) {
        console.log(err)
        this.$store.commit('loaderOn', false)
        let errorLog = err.response.data.callTraces
        traceService.updateCallTraces(this.srcNetwork, errorLog, true)
        this.error = this.$t('RESULT_ERROR')
      }
    }

  }
}
</script>
<template>
  <div class="container container-height">
    <div class="row mt-4">
      <div class="col">
        <h3 v-if="totalItems > 0">
          {{ $t("header.cart") }}
        </h3>
      </div>
      <div
        v-if="!isLoggedIn"
        class="col">
        <small class="pull-right text-muted text-right">
          {{ $t("label.returnCustomer") }}
          <button
            id="sign-in-btn"
            class="btn btn-primary btn-lg ml-2"
            type="button"
            @click="accountPage()">
            {{ $t("label.signIn") }}
          </button>
        </small>
      </div>
    </div>
    <div class="border-dark border-top my-2" />
    <div
      v-if="totalItems > 0"
      class="row">
      <div class="col-xs-12 col-md-6 mx-auto mt-4">
        <h4 class="font-weight-bold">
          {{ $t("header.orderSummary") }}
        </h4>
        <div class="pl-md-3">
          <cart-items :cart-details="cartDetails" />
        </div>
        <div class="mt-4 pl-md-3">
          <button
            id="continue-shopping-btn"
            class="btn border-primary text-primary btn-lg pull-left mb-4 mr-3"
            @click="homePage()">
            {{ $t("label.continueShopping") }}
          </button>
          <button
            id="empty-cart-btn"
            class="btn btn-primary btn-lg mb-4"
            @click="emptyCart()">
            {{ $t("label.emptyCart") }}
          </button>
        </div>
      </div>

      <div class="col-md-5 col-xs-12 mx-auto">
        <div
          v-if="error"
          class="alert alert-danger"
        >
          {{ error }}
        </div>
        <div
          v-if="isCardPaymentInfoVisible"
          id="fido-card-payment-info"
          class="my-4">
          <div class="d-flex justify-content-between align-items-center mb-4">
            <div><h4 class="font-weight-bold m-0 p-0">
              {{ $t("label.saveCard") }}
            </h4></div>
            <div>
              <a
                v-if="hidePayBySavedCard"
                class="cursor-pointer"
                @click="resetComponent">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="24"
                  height="24"
                  viewBox="0 0 50 50"> <path d="M 9.15625 6.3125 L 6.3125 9.15625 L 22.15625 25 L 6.21875 40.96875 L 9.03125 43.78125 L 25 27.84375 L 40.9375 43.78125 L 43.78125 40.9375 L 27.84375 25 L 43.6875 9.15625 L 40.84375 6.3125 L 25 22.15625 Z"/> </svg>
              </a>
            </div>
          </div>

          <div
            v-if="!hidePayBySavedCard"
            class="card_list">
            <component
              :is="activeComp"
              :card="selectedSavedCard"
              :only-unbind="isUnbindRequested"
              @onCardSelected="onCardInfoChange"
              @onUnbindClick="navigateToUnbind"
              @onCheckoutApproachSelection="checkoutApproachChange"
              @onBindingIdSelection="bindingDetailsChange" />
          </div>
          <div
            v-if="isUnbindRequested"
            class="dropdown d-inline">
            <button
              id="card-unbind-button"
              :disabled="disableUnbindButton"
              class="btn btn-primary btn-lg mt-3 px-4 mx-3 dropdown-toggle"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false">
              {{ $t("label.unbindMFALable") }}
            </button>
            <div
              class="dropdown-menu cursor-pointer"
              aria-labelledby="unbindDropdownMenuButton">
              <a
                v-if="selectedBindingDetails && selectedBindingDetails.mfaMethodInstanceId"
                class="dropdown-item cursor-pointer"
                @click="unbindMFA('mfaMethodInstanceId')">{{ $t("label.unbindMFALable1") }}</a>
              <a
                v-if="selectedBindingDetails && selectedBindingDetails.externalMfaMethodInstanceId"
                class="dropdown-item cursor-pointer"
                @click="unbindMFA('externalMfaMethodInstanceId')">{{ $t("label.unbindMFALable2") }}</a>

              <a
                v-if="selectedBindingDetails && selectedBindingDetails.mfaMethodInstanceId"
                class="dropdown-item cursor-pointer"
                @click="unbindMFA('resourceId','mfaMethodInstanceId')">{{ $t("label.unbindMFALable4") }}</a>
              <a
                v-if="selectedBindingDetails && selectedBindingDetails.externalMfaMethodInstanceId"
                class="dropdown-item cursor-pointer"
                @click="unbindMFA('resourceId','externalMfaMethodInstanceId')">{{ $t("label.unbindMFALable5") }}</a>
              <a
                class="dropdown-item cursor-pointer"
                @click="unbindMFA('resourceId')">{{ $t("label.unbindMFALable3") }}</a>

            </div>
          </div>
          <button
            v-if="merchantSavedCards.length > 0 && !hidePayBySavedCard && !isUnbindRequested"
            id="card-continue-button"
            :disabled="disableSavedCardContinueButton"
            class="btn btn-primary btn-lg my-3 ml-3 px-5"
            data-test="card-btn-continue"
            type="submit"
            @click="checkoutWithSavedCard()">
            {{ $t("label.continueLabel") }}
          </button>
        </div>
        <h4
          v-if="!invisibleCheckout && !hidePayBySavedCard"
          class="mb-4 font-weight-bold mt-4">
          {{ $t("header.selectPaymentMethod") }}
        </h4>
        <h4
          v-if="invisibleCheckout"
          class="mb-4 font-weight-bold">
          {{ $t("header.selectClickToPay") }}
        </h4>
        <div :class="{ card: invisibleCheckout }">
          <h4 :class="{ 'card-header bg-white': invisibleCheckout }">
            <div
              v-if="invisibleCheckout"
              class="mx-2">
              <SdkLogo />
              <span
                id="cancel-btn"
                class="float-right cursor-pointer font-weight-bold"
                @click="cancel()">
                {{ $t("header.closeIcon") }}
              </span>
            </div>
          </h4>
          <div class="p-0">
            <div v-if="preCheckoutLoader">
              <div class="text-center">
                <div
                  class="spinner-border m-5"
                  role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div>
                  {{ $t("label.initializingSdk") }}
                </div>
              </div>
            </div>
            <div v-else>
              <div v-if="!invisibleCheckout">
                <div
                  v-for="(paymentMethod, index) in paymentOptions"
                  :key="paymentMethod"
                  class="pl-md-3">
                  <div
                    v-if="!hidePayBySavedCard && index === 0"
                    class="mb-3">
                    <label class="radio d-inline">
                      <img
                        :class="paymentMethod.toLowerCase()"
                        :src="require('@/assets/images/' +
                          paymentOptionLabels[paymentMethod].image)
                        ">
                      <span class="align-middle">
                        {{ paymentOptionLabels[paymentMethod].label }}
                      </span>
                      <input
                        :id="'paymentOption'"
                        v-model="defaultPaymentOption"
                        :value="paymentMethod"
                        class="d-inline"
                        type="radio">
                      <span class="check" />
                    </label>
                  </div>
                  <div
                    v-if="index === 1"
                    class="mb-3">
                    <label class="radio d-inline">
                      <img
                        :class="paymentMethod.toLowerCase()"
                        :src="require('@/assets/images/' +
                          paymentOptionLabels[paymentMethod].image)
                        ">
                      <span class="align-middle">
                        {{ paymentOptionLabels[paymentMethod].label }}
                      </span>
                      <input
                        :id="'paymentOption'"
                        v-model="defaultPaymentOption"
                        :value="paymentMethod"
                        class="d-inline"
                        type="radio">
                      <span class="check" />
                    </label>
                  </div>
                  <div v-if="paymentMethod === payByCard">
                    <pay-by-card :show-enroll="!showClickToPay" />
                  </div>
                  <button
                    v-if="showClickToPay && paymentMethod === clickToPay"
                    id="src-button"
                    class="btn rounded-pill p-0 mb-3 ml-3"
                    type="button"
                    @click="openSrc()">
                    <img
                      :src="require('@/assets/images/src_checkout.png')"
                      class="config-src-btn">
                  </button>
                </div>
              </div>
              <div v-else>
                <invisible-srci />
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="invisibleCheckout"
          class="text-center mt-2 mb-3">
          <a
            id="learn-more"
            :href="appExternalLinks.CLICK_TO_PAY_LINK"
            class="text-dark"
            target="_blank">
            <u>{{ $t("label.learnMore") }}</u>
          </a>
        </div>
      </div>
    </div>
    <div
      v-if="totalItems === 0"
      class="text-center mt-12">
      <h2>
        {{ $t("label.emptyShoppingCart") }}
      </h2>
      <h5 class="mt-3">
        {{ $t("label.chooseProducts") }}
      </h5>
      <button
        id="continue-shopping-button"
        class="btn border-primary text-primary btn-lg mt-3"
        @click="homePage()">
        {{ $t("label.continueShopping") }}
      </button>
    </div>
  </div>
</template>
